import styles from '../includes/default.styles.js';

export default styles;
